"use client";

import { Command } from "cmdk";
import { Fragment, type PropsWithChildren } from "react";
import { match } from "ts-pattern";
import { type CMDKPage, useCommand } from "~/app/[lang]/command/Context";

interface CommandInnerProps extends PropsWithChildren {
	titles: Record<CMDKPage, string>;
}

export function CommandInner({ titles, children }: CommandInnerProps) {
	const { pages } = useCommand();

	return (
		<Fragment>
			{!!pages.length && (
				<div className="mb-2 flex space-x-2 text-xs">
					{pages.map((p) => (
						<div key={p} className="rounded bg-shades-light px-1 py-0.5 text-shades-dark">
							{match(p)
								.with("home", () => titles.home)
								.with("language", () => titles.language)
								.with("cart", () => titles.cart)
								.with("mainCategory", () => titles.mainCategory)
								.with("furnitureCategory", () => titles.furnitureCategory)
								.with("accessoriesCategory", () => titles.accessoriesCategory)
								.otherwise(() => p)}
						</div>
					))}
				</div>
			)}

			<Command.List className="scrollbar-none max-h-[calc(36rem-85px-2rem)] overflow-auto">
				{children}
			</Command.List>
		</Fragment>
	);
}
